function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useCallback } from 'react';
import { PropTypes } from 'prop-types';
import { pluralize } from 'humanize-plus';
import ExpandableButton from '../ExpandableButton';
import AuthorizationSpendCard from './AuthorizationSpendCard';
var ReferralAuthSpendExpandable = function ReferralAuthSpendExpandable(_ref) {
  var title = _ref.title,
    items = _ref.items,
    totalSpend = _ref.totalSpend,
    unit = _ref.unit,
    isAuthorized = _ref.isAuthorized,
    isCostBased = _ref.isCostBased;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var onClick = useCallback(function () {
    setIsOpen(function (prevIsOpen) {
      return !prevIsOpen;
    });
  }, []);
  var requestCount = "".concat(items.length, " ").concat(pluralize(items.length, 'request'));
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between my-2"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-dark-grey"
  }, title), /*#__PURE__*/React.createElement("span", null, totalSpend)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("span", null, requestCount), items.length > 0 && /*#__PURE__*/React.createElement(ExpandableButton, {
    isOpen: isOpen,
    onClick: onClick,
    dataTestId: "expandable-button-".concat(isAuthorized ? 'authorized' : 'not-yet-authorized'),
    className: "ml-3"
  })), isOpen && /*#__PURE__*/React.createElement(React.Fragment, null, items.map(function (item) {
    return /*#__PURE__*/React.createElement(AuthorizationSpendCard, {
      key: item.short_id,
      item: item,
      unit: unit,
      isAuthorized: isAuthorized,
      isCostBased: isCostBased,
      cardClassName: "my-3 w-3/4"
    });
  })));
};
ReferralAuthSpendExpandable.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    short_id: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    spend: PropTypes.number.isRequired,
    service_starts_at: PropTypes.string.isRequired,
    service_ends_at: PropTypes.string.isRequired,
    updated_at: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    requester_name: PropTypes.string.isRequired,
    case_state: PropTypes.string.isRequired,
    case_opened_date: PropTypes.string.isRequired
  })).isRequired,
  totalSpend: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  isAuthorized: PropTypes.bool.isRequired,
  isCostBased: PropTypes.bool.isRequired
};
export default ReferralAuthSpendExpandable;
//# sourceMappingURL=ReferralAuthSpendExpandable.js.map